import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourSlugDto from '@/features/dashboard/tours/types/TourSlugDto.ts';

const useGetTourSlug = (tourId: string) => {
  return useQuery(getTourSlugQueryOptions(tourId));
};

export const getTourSlugQueryOptions = (
  tourId: string,
): UseQueryOptions<TourSlugDto> => ({
  queryKey: toursApiQueryKeys.tourSlug(tourId),
  queryFn: () => toursApi.getTourSlug(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60 * 30,
});

export default useGetTourSlug;
